import React, { useState } from 'react';
import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa';
import propTypes from 'prop-types';
import SubjectComments from '../SubjectComments';
import useToast from '../../hooks/useToast';
import useMe from '../../hooks/useMe';
import BtnComments from '../BtnComments';
import AttachmentList from '../AttachmentList';
import useContext from '../../hooks/useContext';

const voteGql = gql`
  mutation vote($subjectId: ID!, $condominiumId: ID!, $option: String!) {
    subjectVote(subjectId: $subjectId, condominiumId: $condominiumId, option: $option) {
      _id
    }
  }
`;

export default function SubjectCard({ assembly, subject, refetch, detailed }) {
  const [isCommentsVisible, setCommentsVisible] = useState(false);
  const [me] = useMe();
  const toast = useToast();
  const { permission } = useContext();
  const [voteFn, { loading }] = useMutation(voteGql, {
    variables: { subjectId: subject._id, condominiumId: assembly.condominium },
    onCompleted: () => {
      toast.fire({ icon: 'success', title: 'Voto computado! ' });
      if (refetch) refetch();
    },
  });

  const vote = args => {
    if (permission !== 'vote') return;
    voteFn(args);
  };

  return (
    <>
      {isCommentsVisible && (
        <SubjectComments
          assembly={assembly}
          subject={subject}
          toggle={() => {
            refetch();
            setCommentsVisible(x => !x);
          }}
        />
      )}
      <div className="card">
        <div className="card-body">
          <div>
            <BtnComments
              comments={(subject.comments || []).length}
              assemblyId={assembly._id}
              condominiumId={assembly.condominium}
              subjectId={subject._id}
            />
            <br />
            <br />
          </div>

          <h5 className="card-title">{subject.title}</h5>
          <p className="card-text">{subject.description}</p>
          <AttachmentList items={subject.attachments} />

          <ul className="list-group">
            {subject.options.map((option, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className="list-group-item" key={`option-${index}`}>
                <button
                  className={`btn btn-clear btn-block text-left btn-default btn-sm ${
                    me && option.votes.includes(me._id) ? 'text-primary' : ''
                  }`}
                  type="button"
                  disabled={loading || assembly.status !== 'opened'}
                  onClick={() => vote({ variables: { option: option._id } })}
                >
                  {(me && option.votes.includes(me._id) && <FaRegCheckCircle />) || <FaRegCircle />}
                  {` ${option.description} (${option.votes.length} voto${option.votes.length > 1 ? 's' : ''})`}
                </button>
                {detailed &&
                  option.votes.map(userVote => (
                    <p className="text-muted ml-3" key={`${userVote._id}`}>
                      {vote.name}
                    </p>
                  ))}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

SubjectCard.propTypes = {
  subject: propTypes.object.isRequired,
  assembly: propTypes.object.isRequired,
  refetch: propTypes.func,
  detailed: propTypes.bool,
};

SubjectCard.defaultProps = {
  refetch: undefined,
  detailed: false,
};
